export enum Fields {
  Email = 'email',
}

export type FormFields = Record<Fields, string>;
